import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

export enum TextSize {
  headline1 = 32,
  headline2 = 24,
  headline3 = 18,
  body1 = 16,
  body2 = 14,
  body3 = 12,
}

export enum TextWeight {
  headline1 = 500,
  headline2 = 500,
  headline3 = 500,
  body1 = 400,
  body2 = 400,
  body3 = 400,
}

export enum TextLineHeight {
  headline1 = 40,
  headline2 = 28,
  headline3 = 21,
  body1 = 24,
  body2 = 16,
  body3 = 14,
}

export type TextPatternType =
  | 'headline1'
  | 'headline2'
  | 'headline3'
  | 'body1'
  | 'body2'
  | 'body3';

export interface TextPropsInterface extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  display?: 'block' | 'inline-block' | 'inline' | 'none';
  weight?: number;
  margin?: string;
  padding?: string;
  cursor?: 'default' | 'pointer';
  color?: string;
  textAlign?: 'center' | 'right' | 'left';
  pattern?: TextPatternType;
  fontSize?: number;
  lineHeight?: number;
  customColor?: string;
  whiteSpace?: 'nowrap' | 'pre-wrap' | 'unset';
  textShadow?: string;
  textOverflow?: 'clip' | 'ellipsis' | 'unset';
  transition?: string;
  height?: string;
  width?: string;
  userSelect?: 'none' | 'auto' | 'text' | 'contain' | 'all';
  textDecoration?: string;
  overflowX?:
    | 'visible'
    | 'hidden'
    | 'clip'
    | 'scroll'
    | 'auto'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset';
  overflowY?:
    | 'visible'
    | 'hidden'
    | 'clip'
    | 'scroll'
    | 'auto'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset';
  overflow?:
    | 'visible'
    | 'hidden'
    | 'clip'
    | 'scroll'
    | 'auto'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset';
}
